import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {UnitTools} from './unitTools.js';


/* global customElements */
class DriverGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var driverGrid = this;
		setTimeout(function(){
			driverGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var driverGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'driverRefNo',
					postinit: function(combo) {						
						var lookups = [							
							{
								code: 'firstName',
								description: 'First Name'								
							},
							{
								code: 'lastName',
								description: 'Last Name'	
							},
							{
								code: 'comment',
								description: 'Comment'	
							},
							{
								code: 'driverRefNo',
								description: 'Reference No'	
							},
							{
								code: 'tags',
								description: 'Tag'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['DRIVER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DRIVER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DRIVER_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:folder-open', ' Details')						
					],
					listeners: {
						click: function() {
							actionDetails(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'status',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DRIVER_MANAGEMENT:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Update Status')						
					],
					listeners: {
						click: function() {
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'dl-action-button',
					itemid: 'refs',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DRIVER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:chevron-circle-right', ' References')						
					],
					listeners: {
						click: function() {
							actionMultiRefs(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['DRIVER_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'driverRefNo',
					header: 'Reference No',
					width: '7em'
				},	
				{						
					path: 'firstName',
					header: 'First Name',
					width: '7em'
				},
				{						
					path: 'lastName',
					header: 'Last Name',
					width: '7em'
				},
				{						
					path: 'city',
					header: 'City',
					width: '7em'
				},
				{						
					path: 'stateProvCode',
					header: 'State',
					width: '7em'
				},
				{						
					path: 'comment',
					header: 'Comment',
					width: '7em'
				},
				{						
					path: 'tags',
					header: 'Tags',
					width: '12em',
					renderer: function(root, column, rowData) {
						var tags = [];
						if (rowData.item.tags) { 
							rowData.item.tags.forEach(function(tagItem) {
								tags.push(
									'<span class="tag-badge" style="margin: 3px;">' + tagItem + '</span>'
								);
							});
						}
						
						root.innerHTML = tags.join('');
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'details').disabled = false;
						ElementUtil.query(toolbar, 'status').disabled = false;
						ElementUtil.query(toolbar, 'refs').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'details').disabled = true;
						ElementUtil.query(toolbar, 'status').disabled = true;
						ElementUtil.query(toolbar, 'refs').disabled = true;
					}
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;	
					ElementUtil.query(toolbar, 'details').disabled = true;
					ElementUtil.query(toolbar, 'status').disabled = true;
					ElementUtil.query(toolbar, 'refs').disabled = true;					
				}	
			});
		};	
			
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',			
			children: [				
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					UnitService.getDriverService().exportDriver(grid.currentFilter);
				}
			}
		});			
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'driverRefNo',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							status: ElementUtil.query(toolbarFilter, 'status').value,
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value							
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;
							
							grid.selectedItems = [];
							gridSelectionChange();

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						UnitService.getDriverService().getDrivers(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});		
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		driverGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(driverGrid, toolbarFilter, ['filterType','filterValue','status'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Driver' : 'Add Driver',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'driverRefNo',
											label: 'Reference No',
											required: true,
											maxLength: 80											
										},
										{
											tag: 'vaadin-text-field',										
											name: 'firstName',
											label: 'First Name',
											maxLength: 80											
										},	
										{
											tag: 'vaadin-text-field',										
											name: 'lastName',
											label: 'Last Name',
											maxLength: 80
										},
										{
											tag: 'vaadin-text-field',										
											name: 'addrLine1',
											label: 'Address Line 1',
											maxLength: 80
										},
										{
											tag: 'vaadin-text-field',										
											name: 'addrLine2',
											label: 'Address Line 2',
											maxLength: 80
										},
										{
											tag: 'vaadin-text-field',										
											name: 'city',
											label: 'City',
											maxLength: 120
										},										
										{
											tag: 'vaadin-combo-box',
											itemid: 'stateProvCodeCB',
											label: 'State/Providence',
											name: 'stateProvCode',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-text-field',										
											name: 'postalCode',
											label: 'Postal Code',
											maxLength: 20
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Driver Type',
											name: 'driverType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DriverType').then(function (data) {
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-text-field',										
											name: 'comment',
											label: 'Comment',
											maxLength: 255
										},										
										{
											//wrap to make sure the layout works
											tag: 'div',
											colspan: 2,
											children: [
												{
													tag: 'dl-tagfield',
													name: 'tags',
													label: 'Tags',
													maxLength: 80
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																		
																													
															formPanel.submitForm({
																preSubmit: function(data) {		
																	var selectedItem = ElementUtil.query(formPanel, 'stateProvCodeCB').selectedItem;
																	if (selectedItem) {																	
																		data.countryCode = selectedItem.country;																	
																	} else {
																		delete data.stateProvCode;
																	}
																	if (data.driverType === '') {
																		delete data.driverType;
																	}
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.driverId = record.driverId;
																	}
																	return UnitService.getDriverService().saveDriver(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Driver', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);
							
						//	var event = new Event('change');
						//	ElementUtil.query(formPanel, 'country').dispatchEvent(event);
						}
					}
				}
			});			
		};
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'DRIVER',
				visibleOptions: [
					'datafilterId',
					'dataTransformRuleSetId',
					'autoGroupId'
				],
				uploadUrl: '/api/resource/drivers/import'
			});
		};
		
		var actionDetails = function(record) {
			UnitTools.displayDetails({
				record: record,
				grid: grid,	
				allData: grid.items.slice(0),
				selectField: 'driverId',
				getDetails: function(data){
					var detail = [
						{
							key: 'Driver Id',
							value: data.driverId
						},
						{
							key: 'Driver Ref No',
							value: data.driverRefNo
						},
						{
							key: 'First Name',
							value: data.firstName
						},
						{
							key: 'Last Name',
							value: data.lastName
						},
						{
							key: 'Address Line 1',
							value: data.addrLine1
						},
						{
							key: 'Address Line 2',
							value: data.addrLine1
						},						
						{
							key: 'City',
							value: data.city
						},			
						{
							key: 'State Prov/Code',
							value: data.stateProvCode ? data.stateProvCode : ''
						},	
						{
							key: 'Country Code',
							value: data.countryCode ? data.countryCode : ''
						},					
						{
							key: 'Driver Type',
							value: data.driverTypeDescription ? data.driverTypeDescription : ''
						},						
						{
							key: 'Deactivate Date',
							value: data.deactivateDts ? TimeUtil.formatDateStandard(data.deactivateDts) : "N/A"  
						},						
						{
							key: 'Comment',
							value: data.comment ? data.comment : ''
						},
						{	
							key: 'Update Date',
							value: TimeUtil.formatDateStandard(data.updateDts)
						},
						{	
							key: 'Update User',
							value: data.updateUser
						}						
					];
					UnitTools.insertV6EntityIdDetail(detail, data);
					
					if (data.tags) {
						detail.push({
							key: 'Tags',
							section: true,
							value: ''
						});
						data.tags.forEach(function(tag){
							detail.push({
								key: '',							
								value: tag
							});
						});
					}
					
					return detail;	
				}		
				
			});
		};
		
		var actionUpdateStatus = function(record) {
			
			if (record.activeStatus === 'A') {
				UnitService.getDriverService().inactivateDriver(record.driverId).then(function(){
					window.DL.MessageUtil.showToast('Success', 'Inactivated - ' + record.driverRefNo);
					actionRefresh();
				});
			} else {
				UnitService.getDriverService().activateDriver(record.driverId).then(function(){
					window.DL.MessageUtil.showToast('Success', 'Activated - ' + record.driverRefNo);
					actionRefresh();
				});				
			}
			
		};
		
		var actionMultiRefs = function(record) {
			UnitTools.multipleReferences({
				loadRefs: function(grid) {
					UnitService.getDriverService().getDriverMultiRefs(record.driverId).then(function(data){
						grid.items = data;
					});
				},
				saveReference: function(data, edit) {
					data.driverId = record.driverId;
					return UnitService.getDriverService().saveDriverMultiRef(data, edit);
				},
				handleDelete: function(referenceId, successCallback) {
					UnitService.getDriverService().deleteDriverMultiRef(record.driverId, referenceId).then(function(){
						successCallback();
					});
				}
			});
		};
		
	}
	
}
customElements.define('dl-driver-grid', DriverGrid);
